module.exports = __webpack_public_path__ + "img/baikal.3c1dbeee.png";